// Author profile picture mapping for blog articles
export const authorProfiles = {
  'Negin Nickparsa': '/images/profiles/negin-nickparsa.jpg',
  'Sara Ahmadi': 'https://randomuser.me/api/portraits/women/32.jpg',
  'Reza Mohammadi': 'https://randomuser.me/api/portraits/men/45.jpg',
  'Dr. Leila Farhadi': 'https://randomuser.me/api/portraits/women/68.jpg',
  'David Chen': 'https://randomuser.me/api/portraits/men/32.jpg',
  'Mina Farrokhzad': 'https://randomuser.me/api/portraits/women/56.jpg',
  'Ahmad Reza Hosseini': 'https://randomuser.me/api/portraits/men/67.jpg',
  'Maryam Karimi': 'https://randomuser.me/api/portraits/women/23.jpg',
  'Hossein Mirza': 'https://randomuser.me/api/portraits/men/75.jpg',
  'Shahram Nazeri': 'https://randomuser.me/api/portraits/men/42.jpg',
  'Dr. Zahra Ahmadi': 'https://randomuser.me/api/portraits/women/33.jpg',
  'Reza Mehrabi': 'https://randomuser.me/api/portraits/men/22.jpg',
  'Nasrin Hosseini': 'https://randomuser.me/api/portraits/women/62.jpg',
  'Mehrdad Karimi': 'https://randomuser.me/api/portraits/men/28.jpg',
  'Ali Rostami': 'https://randomuser.me/api/portraits/men/63.jpg'
};

// Helper function to get author profile picture
export const getAuthorProfilePicture = (authorName: string): string => {
  return authorProfiles[authorName as keyof typeof authorProfiles] || 'https://randomuser.me/api/portraits/men/32.jpg';
};
